import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

// Global router and context for route resolution
let globalRouter = null;
let globalContext = null;
let globalRoot = null;

export function setRouteResolver(router, context, root) {
  globalRouter = router;
  globalContext = context;
  globalRoot = root;
}

export default function RouteResolver({ children }) {
  const location = useLocation();
  const [routeComponent, setRouteComponent] = useState(children);

  useEffect(() => {
    if (!globalRouter || !globalContext) return;

    const resolveRoute = async () => {
      try {
        const query = location.search ? queryString.parse(location.search) : {};
        const newContext = {
          ...globalContext,
          pathname: location.pathname,
          query,
        };

        const route = await globalRouter.resolve(newContext);

        if (route.redirect) {
          window.location.assign(route.redirect);
          return;
        }

        setRouteComponent(route.component);
      } catch (error) {
        console.error('Route resolution error:', error);
      }
    };

    resolveRoute();
  }, [location.pathname, location.search]);

  return routeComponent;
}
